export const ucase = (text) => (text ? `${text.substring(0, 1).toUpperCase()}${text?.toLowerCase().substring(1)}` : '');
